class FormInput {
  constructor() {
    this.inputs = document.querySelectorAll('.form__input, .form__textarea');
    if (!this.inputs.length) return;
    this.init();
  }

  init() {
    this.inputs.forEach(input => {
      const formGroup = input.closest('.form__group');
      if (!formGroup) return;

      this.updateState(input, formGroup);

      input.addEventListener('input', () => this.updateState(input, formGroup));

      input.addEventListener('focus', () => {
        formGroup.classList.add('active-hover');
      });

      input.addEventListener('blur', () => {
        formGroup.classList.remove('active-hover');
        this.updateState(input, formGroup);
      });

      input.addEventListener('mouseenter', () => {
        formGroup.classList.add('active-hover');
      });

      input.addEventListener('mouseleave', () => {
        formGroup.classList.remove('active-hover');
        this.updateState(input, formGroup);
      });
    });
  }

  updateState(input, formGroup) {
    if (input.value.trim()) {
      formGroup.classList.add('active');
    } else {
      formGroup.classList.remove('active');
    }
  }
}

class FileInput {
  constructor() {
    this.fileInput = document.querySelector('.form__file');
    if (!this.fileInput) return;
    this.init();
  }

  init() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.fileInput.addEventListener('change', (e) => this.handleFileChange(e));
  }

  handleFileChange(e) {
    const fileName = e.target.files[0] ? e.target.files[0].name : 'Choose a file...';
    const fileLabel = this.fileInput.nextElementSibling;
    const fileText = fileLabel.querySelector('.form__file-text');

    if (e.target.files.length > 0) {
      fileText.textContent = fileName;
      fileLabel.classList.add('has-file');
    } else {
      fileText.textContent = 'Choose a file...';
      fileLabel.classList.remove('has-file');
    }
  }
}

class CustomSelect {
  static SERVICE_ALIASES = {
    'Поставка табачных изделий': ['tobacco', 'tobacco business', 'тытунёвы бізнес', 'пастаўка тытунёвых вырабаў'],
    'Логистика': ['logistics', 'лагістыка'],
    'Строительство и проектирование': ['construction', 'construction and design', 'будаўніцтва', 'будаўніцтва і праектаванне'],
    'Медицинский центр': ['medical', 'medical center', 'медыцынскі цэнтр'],
    'Рекламные услуги': ['advertising', 'advertising services', 'рэкламныя паслугі'],
    'Отдых и развлечения': ['entertainment', 'leisure and entertainment', 'leisure & entertainment', 'адпачынак і забавы'],
    'Швейные услуги': ['tailoring', 'sewing services', 'швейныя паслугі'],
    'Клининг': ['cleaning', 'cleaning services', 'клінінг'],
    'Профсоюз': ['tradeunion', 'trade union', 'прафсаюз'],
  };

  constructor() {
    this.selects = document.querySelectorAll('.custom-select');
    if (!this.selects.length) return;
    this.init();
  }

  init() {
    this.selects.forEach(select => this.setupSelect(select));
    document.addEventListener('click', () => this.closeAllSelects());
  }

  setupSelect(select) {
    const trigger = select.querySelector('.custom-select__trigger');
    const options = select.querySelector('.custom-select__options');
    const nativeSelect = select.querySelector('select');
    const placeholder = select.querySelector('.custom-select__placeholder');
    const optionItems = select.querySelectorAll('.custom-select__option');
    const prefilledService = select.closest('.contact__form')?.dataset.prefilledService;

    if (nativeSelect) {
      nativeSelect.setAttribute('autocomplete', 'off');
    }

    this.setInitialState(nativeSelect, placeholder, optionItems, prefilledService);
    this.setupEventListeners(select, trigger, nativeSelect, placeholder, optionItems);
  }

  normalizeValue(value) {
    return String(value || '').trim().toLowerCase();
  }

  getAliases(value) {
    const normalized = this.normalizeValue(value);
    if (!normalized) return [];

    const entries = Object.entries(CustomSelect.SERVICE_ALIASES);
    for (const [base, aliases] of entries) {
      const candidates = [base, ...aliases].map(item => this.normalizeValue(item));
      if (candidates.includes(normalized)) {
        return candidates;
      }
    }

    return [normalized];
  }

  isOptionMatch(option, valueOrText) {
    const optionValue = this.normalizeValue(option?.value);
    const optionText = this.normalizeValue(option?.textContent);
    const candidates = this.getAliases(valueOrText);

    return candidates.includes(optionValue) || candidates.includes(optionText);
  }

  getNativeOptionByCustom(optionItem, nativeSelect) {
    const text = optionItem.textContent.trim();
    const value = optionItem.getAttribute('data-value');
    const nativeOptions = Array.from(nativeSelect.options);

    const directMatch = nativeOptions.find(opt => (
      this.isOptionMatch(opt, value) || this.isOptionMatch(opt, text)
    ));
    if (directMatch) {
      return directMatch;
    }

    const customOptions = Array.from(optionItem.closest('.custom-select__options')?.querySelectorAll('.custom-select__option') || []);
    const customIndex = customOptions.indexOf(optionItem);
    if (customIndex === -1) {
      return null;
    }

    const selectableNativeOptions = nativeOptions.filter(opt => this.normalizeValue(opt.value));
    return selectableNativeOptions[customIndex] || null;
  }

  getCustomOptionByNative(selectedOption, optionItems) {
    return Array.from(optionItems).find(item => (
      this.isOptionMatch(selectedOption, item.getAttribute('data-value')) ||
      this.isOptionMatch(selectedOption, item.textContent.trim())
    )) || null;
  }

  setInitialState(nativeSelect, placeholder, optionItems, prefilledService) {
    const select = nativeSelect.closest('.custom-select');
    if (prefilledService && !nativeSelect.value) {
      const prefilledOption = Array.from(nativeSelect.options).find(
        option => this.isOptionMatch(option, prefilledService)
      );

      if (prefilledOption) {
        nativeSelect.value = prefilledOption.value;
        nativeSelect.dispatchEvent(new Event('change'));
        nativeSelect.dispatchEvent(new Event('input'));
      }
    }

    if (nativeSelect.value) {
      const selectedOption = Array.from(nativeSelect.options).find(
        option => option.selected
      );
      if (selectedOption) {
        const matchedCustomOption = this.getCustomOptionByNative(selectedOption, optionItems);
        placeholder.textContent = matchedCustomOption?.textContent.trim() || selectedOption.textContent;
        select?.classList.add('is-selected');

        optionItems.forEach(item => {
          const itemValue = item.getAttribute('data-value');
          if (
            this.isOptionMatch(selectedOption, itemValue) ||
            this.isOptionMatch(selectedOption, item.textContent.trim())
          ) {
            item.classList.add('selected');
          }
        });
      }
    } else {
      select?.classList.remove('is-selected');
    }
  }

  setupEventListeners(select, trigger, nativeSelect, placeholder, optionItems) {
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleSelect(select);
    });

    optionItems.forEach(option => {
      option.addEventListener('click', () => {
        const nativeOption = this.getNativeOptionByCustom(option, nativeSelect);

        if (nativeOption) {
          nativeOption.selected = true;
          placeholder.textContent = option.textContent.trim();
          select.classList.add('is-selected');

          optionItems.forEach(item => item.classList.remove('selected'));
          option.classList.add('selected');

          select.classList.remove('open');

          // Trigger all necessary events
          nativeSelect.dispatchEvent(new Event('change'));
          nativeSelect.dispatchEvent(new Event('input'));
        }
      });
    });

    nativeSelect.addEventListener('change', () => {
      const selectedOption = Array.from(nativeSelect.options).find(option => option.selected && option.value);
      this.updateFromNativeSelect(selectedOption, placeholder, optionItems);
    });
  }

  toggleSelect(select) {
    this.closeAllSelects();
    if (!select.classList.contains('open')) {
      select.classList.add('open');
    }
  }

  closeAllSelects() {
    this.selects.forEach(select => select.classList.remove('open'));
  }

  selectOption(select, nativeSelect, placeholder, option, optionItems, value, text) {
    nativeSelect.value = value;
    placeholder.textContent = text;

    optionItems.forEach(item => item.classList.remove('selected'));
    option.classList.add('selected');

    select.classList.remove('open');
    nativeSelect.dispatchEvent(new Event('change'));
  }

  updateFromNativeSelect(selectedOption, placeholder, optionItems,) {
    const select = placeholder.closest('.custom-select');
    if (selectedOption) {
      const matchedCustomOption = this.getCustomOptionByNative(selectedOption, optionItems);
      placeholder.textContent = matchedCustomOption?.textContent.trim() || selectedOption.textContent;
      select?.classList.add('is-selected');

      optionItems.forEach(item => {
        item.classList.remove('selected');
        if (
          this.isOptionMatch(selectedOption, item.getAttribute('data-value')) ||
          this.isOptionMatch(selectedOption, item.textContent.trim())
        ) {
          item.classList.add('selected');
        }
      });
    } else {
      select?.classList.remove('is-selected');
    }
  }
}

class SelectValidation {
  constructor() {
    this.selects = document.querySelectorAll('.custom-select');
    if (!this.selects.length) return;
    this.init();
  }

  init() {
    this.selects.forEach(select => {
      const trigger = select.querySelector('.custom-select__trigger');
      const hiddenSelect = select.querySelector('.form__select');
      const optionItems = select.querySelectorAll('.custom-select__option');

      if (!trigger || !hiddenSelect) return;

      this.setupValidationObserver(trigger, hiddenSelect);
      this.setupOptionClickHandler(trigger, hiddenSelect, optionItems, select);
    });
  }

  setupValidationObserver(trigger, hiddenSelect) {
    const updateValidationClass = () => {
      if (hiddenSelect.classList.contains('wpcf7-not-valid')) {
        trigger.classList.add('wpcf7-not-valid');
      } else {
        trigger.classList.remove('wpcf7-not-valid');
      }
    };

    updateValidationClass();

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'class') updateValidationClass();
      });
    });

    observer.observe(hiddenSelect, { attributes: true, attributeFilter: ['class'] });
    hiddenSelect.addEventListener('change', updateValidationClass);
  }

  setupOptionClickHandler(trigger, hiddenSelect, optionItems, select) {
    optionItems.forEach(option => {
      option.addEventListener('click', () => {
        const errorTip = select.querySelector('.wpcf7-not-valid-tip');

        trigger.classList.remove('wpcf7-not-valid');
        if (errorTip) {
          errorTip.remove();
        }

        hiddenSelect.classList.remove('wpcf7-not-valid');

        hiddenSelect.removeAttribute('aria-invalid');
      });
    });
  }
}

class Wpcf7submit {
  constructor() {
    this.init();
  }

  init() {
    this.submitHandle();
    this.formSubmitButtonHandler();
    this.disableSubmitButton();
  }

  formSubmitButtonHandler() {
    document.addEventListener('wpcf7submit', () => {
      this.enableSubmitButton();
      this.removeFormLoading();
    });

    document.addEventListener('wpcf7invalid', () => {
      this.enableSubmitButton();
      this.removeFormLoading();
    });

    document.addEventListener('wpcf7mailsent', () => {
      this.enableSubmitButton();
      this.removeFormLoading();
    });

    document.addEventListener('wpcf7mailfailed', () => {
      this.enableSubmitButton();
      this.removeFormLoading();
    });
  }

  submitHandle() {
    document.addEventListener('wpcf7submit', (event) => {
      const response = event.detail.apiResponse;
      const status = response.status;
      const message = response.message || 'Oops something went wrong.';

      switch (status) {
        case 'mail_sent':
          alertNotification.success(message);
          break;
        case 'validation_failed':
          alertNotification.error(message);
          break;
        case 'mail_failed':
          alertNotification.error(message);
          break;
        default:
          alertNotification.info(message);
      }
    }, false);
  }

  disableSubmitButton() {
    document.addEventListener('wpcf7beforesubmit', () => {
      const submitButtons = document.querySelectorAll('.wpcf7-submit');
      submitButtons.forEach(button => {
        button.disabled = true;
      });
      this.addFormLoading();
    });
  }

  enableSubmitButton() {
    const submitButtons = document.querySelectorAll('.wpcf7-submit');
    submitButtons.forEach(button => {
      button.disabled = false;
    });
  }

  addFormLoading() {
    const formWrappers = document.querySelectorAll('.form-wrapper');
    formWrappers.forEach(wrapper => {
      wrapper.classList.add('is-loading');
    });
  }

  removeFormLoading() {
    const formWrappers = document.querySelectorAll('.form-wrapper');
    formWrappers.forEach(wrapper => {
      wrapper.classList.remove('is-loading');
    });
  }
}
class CheckboxAgreement {
  constructor() {
    this.checkboxes = document.querySelectorAll('.form__checkbox');
    if (!this.checkboxes.length) return;
    this.init();
  }

  init() {
    document.addEventListener('wpcf7beforesubmit', (e) => this.handleSubmit(e));
    
    this.checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        const label = checkbox.closest('.form__checkbox-label');
        if (label) {
          label.classList.remove('is-submit-error');
        }
      });
    });
  }

  handleSubmit(e) {
    const form = e.target;
    if (!form) return;
    
    const checkboxes = form.querySelectorAll('.form__checkbox');
    checkboxes.forEach(checkbox => {
      if (!checkbox.name) return;
      
      const label = checkbox.closest('.form__checkbox-label');
      
      if (!checkbox.checked) {
        if (label) {
          label.classList.add('is-submit-error');
        }
      } else {
        if (label) {
          label.classList.remove('is-submit-error');
        }
      }
      
      const existingHidden = form.querySelector(`input[type="hidden"][name="${checkbox.name}"]`);
      if (existingHidden) {
        existingHidden.remove();
      }
      
      if (!checkbox.checked) {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = checkbox.name;
        hiddenInput.value = '0';
        form.appendChild(hiddenInput);
      } else {
        checkbox.value = '1';
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new FormInput();
  new FileInput();
  new CustomSelect();
  new SelectValidation();
  new Wpcf7submit();
  new CheckboxAgreement();
});

